import { ReactAppProcessEnv, StandardProceessEnv } from '@iotv/iotv-v3-types'

export type DebugLambdaSettings = {
  DEBUG_OVERRIDE: string
  DEBUG_OVERRIDE_HOURS_LIMIT: string
  LAST_DEPLOY_UTC: string
  LOG_AT_LEVEL: string
}

const REACT_APP_PROJECT_CODE = (process.env as ReactAppProcessEnv).REACT_APP_PROJECT_CODE
const {
  DEBUG_OVERRIDE: L_DEBUG_OVERRIDE,
  DEBUG_OVERRIDE_HOURS_LIMIT,
  LAST_DEPLOY_UTC,
  LOG_AT_LEVEL,
}: Partial<DebugLambdaSettings> = process.env as Partial<DebugLambdaSettings>
const IS_LAMBDA = process.env.AWS_SESSION_TOKEN !== undefined
const NOT_LAMBDA = !IS_LAMBDA && !(REACT_APP_PROJECT_CODE && process.env.NODE_ENV === 'production')

const IS_FARGATE = process.env.AWS_EXECUTION_ENV === 'AWS_ECS_FARGATE'

const userDebugOverride = L_DEBUG_OVERRIDE === 'true'

const nowUTC: Date = new Date()

const deployUTC: Date | undefined = LAST_DEPLOY_UTC ? new Date(LAST_DEPLOY_UTC) : undefined

const hoursLimit: number | undefined = DEBUG_OVERRIDE_HOURS_LIMIT ? parseInt(DEBUG_OVERRIDE_HOURS_LIMIT) : undefined

const cutoffUTC: Date | undefined = deployUTC ? new Date(deployUTC) : undefined
if (cutoffUTC && hoursLimit) {
  cutoffUTC.setHours(cutoffUTC.getHours() + hoursLimit)
}

const DEBUG_OVERRIDE =
  userDebugOverride && deployUTC !== undefined && hoursLimit !== undefined && cutoffUTC !== undefined && cutoffUTC.valueOf() > nowUTC.valueOf()

userDebugOverride &&
  console.log('Consts in lambdaDebug', { IS_LAMBDA, NOT_LAMBDA, nowUTC, deployUTC, hoursLimit, cutoffUTC, userDebugOverride, DEBUG_OVERRIDE })

export { DEBUG_OVERRIDE, IS_LAMBDA, NOT_LAMBDA, LOG_AT_LEVEL, IS_FARGATE }
